import classNames from "classnames";
import { Fragment, useContext } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import RolesList from "./RolesList";

const RolesListWrapper = () => {

    // STATES

    const breadCrumb = [
        { name: 'Roles', href: menuRoutes.roles.path },
        { name: 'Listado', href: menuRoutes.roles.path },
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    // RENDER

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de roles" breadcrumb={breadCrumb}>
                    <Button
                        color="primary"
                        onClick={() => { navigate(menuRoutes.roles.create) }}
                        className={cn('mt-3 md:mt-0',[classNames({ 'hidden': !userCan('create', 'role') })])}
                    >
                        Crear rol
                    </Button>
                </PageHeader>
                <RolesList />
            </FiltersProvider>
        </Fragment>
    );
}

export default RolesListWrapper;